"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _lodash = _interopRequireDefault(require("lodash"));

var _AnalyticsContext = _interopRequireDefault(require("./AnalyticsContext"));

var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var children = _ref.children,
      config = _ref.config;

  var hasTrackingId = _lodash.default.get(config, 'gaTrackingID');

  (0, _react.useEffect)(function () {
    if (hasTrackingId) {
      var gaTrackingID = config.gaTrackingID,
          options = (0, _objectWithoutPropertiesLoose2.default)(config, ["gaTrackingID"]);
      console.log('[ReactGA] initialize', options);

      _reactGa.default.initialize(gaTrackingID, options);

      _reactGa.default.set({
        islogged: false
      });
    }
  }, [config, hasTrackingId]);

  if (hasTrackingId) {
    return /*#__PURE__*/_react.default.createElement(_AnalyticsContext.default.Provider, {
      value: {
        enabled: Boolean(hasTrackingId),
        set: _reactGa.default.set,
        event: _reactGa.default.event,
        pageview: _reactGa.default.pageview,
        modalview: _reactGa.default.modalview
      }
    }, children);
  }

  return children;
};

AnalyticsProvider.propTypes = {
  /** See [here](https://github.com/react-ga/react-ga#api) for more information */
  config: _propTypes.default.shape({
    /** Required. GA Tracking ID like UA-000000-01. */
    gaTrackingID: _propTypes.default.string,

    /** If set to true, will output additional feedback to the console. */
    debug: _propTypes.default.bool,

    /** If set to false, strings will not be converted to title case before sending to GA. */
    titleCase: _propTypes.default.bool,

    /** Enables test mode. See here for more information. */
    testMode: _propTypes.default.bool
  })
};
AnalyticsProvider.displayName = 'AnalyticsProvider';
var _default = AnalyticsProvider;
exports.default = _default;